import { get } from "../../utils/objectHelpers";

$ {
    const card = get(input, "card", {});
    const spinnerModule =  get(input, 'spinnerModule', {});
    const url = get(card, "action.URL", null);
    const title = get(card, "title", {});
    const subTitle = get(card, "subTitle", null);
    const buttonTextSpans = get(card, "slug.textSpans", null);
    const legalTextSpans = get(card, "button.textSpans", null);
    const legalSource = get(card, "button.action.URL", null);
    const image = get(card, "image", {});
    const isAjax = get(card, "action.clientPresentationMetadata.ajax") === "true";
    let trackingData = get(card, "action.trackingList.[0]", {});
    trackingData = JSON.stringify(trackingData);
}

class {
    // This assumes the ajax buttons are for the Category filter.
    // Update if there's another variation.
    fetchCategoryListings(url) {
        const evt = new CustomEvent('ajax-module-update-event', {
            detail: {
                url: url,
                updateEvent: 'categoryFilterEvent',
                type: 'marketingBannerType',
                spinnerId: 'marketingBannerLoadingSpinner'
            }
        });
        document.dispatchEvent(evt);
    }
}

<section class="str-marketing-banner app-layout--negate-gutters-small">
    <div class="str-marketing-banner__text">
        <h2 class="str-marketing-banner__text--title"><str-textual-display ...title /></h2>
        <if(subTitle)>
            <h4 class="str-marketing-banner__text--sub-title"><str-textual-display ...subTitle /></h4>
        </if>
        <div class="str-marketing-banner__text--button">
            <if(isAjax)>
                <ebay-button on-click("fetchCategoryListings", url)
                    data-track=trackingData
                    priority="primary"
                    size="large">
                    <str-textual-display textSpans=buttonTextSpans />
                </ebay-button>
            </if>
            <else>
                <ebay-button priority="primary" size="large" href=url data-track=trackingData >
                    <str-textual-display textSpans=buttonTextSpans />
                </ebay-button>
            </else>
        </div>
        <if(legalTextSpans && legalSource)>
            <str-legal-lightbox linkTextSpans=legalTextSpans source=legalSource />
        </if>
    </div>
    <if(isAjax)>
        <button on-click("fetchCategoryListings", url) data-track=trackingData class="str-marketing-banner__ajax-btn">
            <str-image-square class="str-marketing-banner__image" ...image />
        </button>
    </if>
    <else>
        <str-image-square href=url class="str-marketing-banner__image" ...image data-track=trackingData />
    </else>
    <str-loading-spinner ...spinnerModule spinnerId="marketingBannerLoadingSpinner" />
</section>
